import { OrganizationRole } from '@/graphql';

import { useUserLoading } from './useUser';

/**
 * Returns whether the current user has admin permissions, meaning they can access to all workspace settings, including billing, user management, secrets, etc.
 */
function useIsOrgAdmin(): boolean {
  const { user } = useUserLoading();
  return !!user.roleName && user.roleName === OrganizationRole.Admin;
}

export { useIsOrgAdmin };
